import { render } from "@/components/pages/dataMonitor/MarkPage.html?vue&type=template&id=754da4ab&external"
import script from "@/components/pages/dataMonitor/MarkPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataMonitor/MarkPage.js?vue&type=script&lang=js&external"

import "@/components/pages/dataMonitor/MarkPage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__